
import { useEffect, useState } from "react";
import "./Questionpalette.scss";
import CloseSvg from "@Assets/svg/MockTest-svgs/Close.svg";
import { MathJax } from "better-react-mathjax";
export const QuestionPaletteIndex = ({ questions, jumpToQuestionHandler, onClickBackButtonHandler, testType, fullQuestionPaperMode, activeIndex, pendingAnswers = [] }: any) => {
    const enum testtype {
        Regular = 1,
        Speed
    }
    const Questions = questions;

    const onClickBackButton = (value: boolean) => {
        onClickBackButtonHandler?.(value)
    }

    useEffect(() => {
        if (activeIndex !== undefined) {
            // Use setTimeout to ensure the DOM has updated with the new activeIndex class/id
            setTimeout(() => {
                const id = fullQuestionPaperMode ? `q-item-full-${activeIndex}` : `q-item-${activeIndex}`;
                const activeElement = document.getElementById(id) || document.querySelector('.active-current');
                if (activeElement) {
                    activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    }, [activeIndex, fullQuestionPaperMode]);

    return (
        <>
            <div className="q-n-ui-1">
                <a href="javascript:void(0)" className="close-pallete-1 tw-mt-2" onClick={() => onClickBackButton(false)}>
                    <img src={CloseSvg} alt="close-svg-img" />
                </a>
                {/* {Questions && Questions.length > 0 && (
                    <div className="q-n-header">
                        <h2 className="q-n-h2"> Question Number </h2>
                    </div>
                )} */}
                {(() => {
                    if (testType === 2) {
                        return (
                            <div className="q-n-contents">
                                {fullQuestionPaperMode ?
                                    <ul className="full-qust-ul">
                                        {Questions && Questions.map((question: any, index: number) => (
                                            <li key={index} 
                                                id={`q-item-full-${index}`}
                                                className={`${question.previousQuestionAnswer === false
                                                ? 'active-not'
                                                : question?.SelectedOption
                                                    ? 'active-selected'
                                                    : question?.IsVisited
                                                        ? 'active-2'
                                                        : ''
                                                } ${index === activeIndex ? 'active-current' : ''}`}
                                                onClick={() => jumpToQuestionHandler(index)} >
                                                <MathJax dangerouslySetInnerHTML={{ __html: `<div class="full-qust-li"><span class="full-qust-palette">${index + 1}</span> <span class="palette-qust">${question.Question}</span></div>` }} dynamic={true} >
                                                </MathJax>
                                            </li>
                                        ))}
                                    </ul>
                                    :
                                    <ul className="q-n-lists">
                                        {/* Previously answered questions from pending state */}
                                        {pendingAnswers && pendingAnswers.map((pending: any, idx: number) => (
                                            <li
                                                key={`pending-${idx}`}
                                                className={pending.IsCorrect ? 'active' : 'active-not'}
                                                title={pending.IsCorrect ? 'Correct' : 'Incorrect'}
                                            >
                                                {idx + 1}
                                            </li>
                                        ))}
                                        {/* Current session questions */}
                                        {Questions && Questions.map((question: any, index: number) => (
                                            <li key={index}
                                                id={`q-item-${index}`}
                                                className={`${question.previousQuestionAnswer === false
                                                ? 'active-not'
                                                : question.previousQuestionAnswer === true
                                                    ? 'active'
                                                    : question?.SelectedOption
                                                        ? 'active-selected'
                                                        : question?.IsVisited
                                                            ? 'active-2'
                                                            : ''
                                                } ${index === activeIndex ? 'active-current' : ''}`}
                                                onClick={() => jumpToQuestionHandler(index)}> {pendingAnswers.length + index + 1} </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                        );
                    }

                    const subjects: string[] = [];
                    const groupedQuestions: any = {};
                    Questions && Questions.forEach((question: any, index: number) => {
                        const subject = question.SubjectName || "General";
                        if (!groupedQuestions[subject]) {
                            groupedQuestions[subject] = [];
                            subjects.push(subject);
                        }
                        groupedQuestions[subject].push({ ...question, originalIndex: index });
                    });

                    return (
                        <div className="q-n-contents">
                            {subjects.map((subject) => (
                                <div key={subject} className="subject-group">
                                    <h3 className={`subject-subheading ${subject.toUpperCase()==="MATHS"? "text-blue-500":subject.toUpperCase()==="PHYSICS"? "text-green-500":subject.toUpperCase()==="CHEMISTRY"?"text-pink-500":subject.toUpperCase()==="BIOLOGY"?"text-yellow-500": "text-purple-500"}`}>{subject.toUpperCase()}</h3>
                                    {fullQuestionPaperMode ?
                                        <ul className="full-qust-ul">
                                            {groupedQuestions[subject].map((question: any) => {
                                                const index = question.originalIndex;
                                                return (
                                                    <li key={index} 
                                                        id={`q-item-full-${index}`}
                                                        className={`${testType === 1
                                                        ? question.previousQuestionAnswer === false
                                                            ? 'active-not'
                                                            : question.IsFlag && question.SelectedOption
                                                                ? 'active red-flag'
                                                                : question.SelectedOption
                                                                    ? 'active'
                                                                    : question.IsVisited && question.IsFlag
                                                                        ? 'active-2 red-flag'
                                                                        : question.IsVisited
                                                                            ? 'active-2'
                                                                            : question.IsFlag
                                                                                ? 'red-flag'
                                                                                : ''
                                                        : ''
                                                        } ${index === activeIndex ? 'active-current' : ''}`}
                                                        onClick={() => jumpToQuestionHandler(index)} >
                                                        <MathJax dangerouslySetInnerHTML={{ __html: `<div class="full-qust-li"><span class="full-qust-palette">${index + 1}</span> <span class="palette-qust">${question.Question}</span></div>` }} dynamic={true} >
                                                        </MathJax>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        :
                                        <ul className="q-n-lists">
                                            {groupedQuestions[subject].map((question: any) => {
                                                const index = question.originalIndex;
                                                return (
                                                    <li key={index} 
                                                        id={`q-item-${index}`}
                                                        className={`${testType === 1
                                                        ? question.previousQuestionAnswer === false
                                                            ? 'active-not'
                                                            : question.IsFlag && question.SelectedOption
                                                                ? 'active red-flag'
                                                                : question.SelectedOption
                                                                    ? 'active'
                                                                    : question.IsVisited && question.IsFlag
                                                                        ? 'active-2 red-flag'
                                                                        : question.IsVisited
                                                                            ? 'active-2'
                                                                            : question.IsFlag
                                                                                ? 'red-flag'
                                                                                : ''
                                                        : ''
                                                        } ${index === activeIndex ? 'active-current' : ''}`}
                                                        onClick={() => jumpToQuestionHandler(index)} > {index + 1} </li>
                                                )
                                            })}
                                        </ul>
                                    }
                                </div>
                            ))}
                        </div>
                    );
                })()}
            </div>
        </>
    )
}